export default "__VITE_ASSET__66f33da8__"